<template>
  <user-course-register>
    <template v-slot:step2>
      <v-card flat>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-switch v-model="courseHasModules"
                        :label="(courseHasModules ? 'O Curso possui módulos' : 'O curso não possui módulos')"></v-switch>
            </v-col>
          </v-row>
          <div v-if="courseHasModules">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="modulePresential"
                    :items="types"
                    class="user-type"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-x
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="moduleStartDate"
                        label="Data de início"
                        prepend-icon="event"
                        v-bind="attrs"
                        @blur="date = parseDate(moduleStartDate)"
                        v-on="on"
                        clearable
                        :rules="[rules.requiredPresential]"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field v-model="moduleName"
                                @keyup="addModuleEvent"
                                @click:append-outer="addModule"
                                label="Nome do Módulo"
                                color="blue"
                                :rules="[rules.required]"
                                :append-outer-icon="appendOuterIcon"
                                required>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-chip class="v-chip-modules" :color="module.color || ''" v-for="(module, $index) in modules" :key="$index"
                    close
                    @click:close="removeModule($index)">
              <v-avatar v-if="module._id" style="cursor: pointer;" @click="editModule(module._id)">
                <v-icon>edit</v-icon>
              </v-avatar>
              {{ module.title }}
              <span class="ml-1 white--text" v-if="module.startAt">({{ module.startAt | formatDateContent }})</span>
              <span class="ml-1 white--text" v-if="module.presential">(presencial)</span>
            </v-chip>
          </div>
        </v-card-text>
        <v-card-actions class="btns-action">
          <v-btn color="green" dark :to="{name:'course-create-step1', params: {courseId}}" class="mt-3 ml-0">Voltar
          </v-btn>
          <v-divider></v-divider>
          <v-btn color="green" dark @click="next" class="mt-3 ml-0">Avançar</v-btn>
        </v-card-actions>

      </v-card>
    </template>
  </user-course-register>
</template>

<script>
import UserCourseRegister from '@/views/User/CourseRegister'
import { isValidCNPJ, isValidCPF } from '@/helpers'

export default {
  name: 'UserCourseRegisterStep2',
  components: {
    UserCourseRegister,
  },
  data: (vm) => {
    return {
      valid: true,
      menu1: false,
      date: new Date().toISOString().substr(0, 10),
      moduleStartDate: '',
      // moduleStartDate: vm.formatDate(new Date().toISOString().substr(0, 10)),
      types: [
        { value: 0, text: 'Não é presencial' },
        { value: 1, text: 'É presencial' },
      ],
      loading: false,
      courseHasModules: false,
      moduleId: '',
      moduleName: '',
      modulePresential: 0,
      appendOuterIcon: 'add',
      modules: [],
      rules: {
        required: (value) => !!value || 'Obrigatório',
        requiredPresential: (value) => {
          if (vm.modulePresential === 1 && !value) {
            return 'Obrigatório para módulo presencial'
          }

          return true
        }
      }
    }
  },
  computed: {
    courseId: function () {
      return this.$route.params.courseId
    }
  },
  watch: {
    modules (val) {
      this.courseHasModules = val.length
    },
    date (val) {
      this.moduleStartDate = this.formatDate(val)
    },
  },
  created () {
    this.getModules(this.courseId)
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    addModule () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const data = {
          title: this.moduleName,
          isPresential: this.modulePresential === 1
        }

        if (this.moduleId) {
          data.moduleId = this.moduleId
        } else {
          data.courseId = this.courseId
        }

        if (this.moduleStartDate) {
          data.startDate = this.parseDate(this.moduleStartDate)
        }

        this.axios.request({
          method: (this.moduleId ? 'PUT' : 'POST'),
          url: '/user/module',
          data
        }).then(({ data }) => {
          if (data.success) {
            this.moduleName = ''
            this.moduleStartDate = ''
            this.modulePresential = 0

            // SE ESTIVER EDITANDO UM MÓDULO
            if (this.moduleId) {
              let index = this.modules.findIndex(module => {
                return String(this.moduleId) === String(module._id)
              })

              if (index !== -1) {
                this.modules[index].title = data.module.title
                this.modules[index].color = ''
              }

              this.moduleId = ''
              this.appendOuterIcon = 'add'
            } else {
              this.modules.push(data.module)
            }
          }
        }).catch(() => {
          this.$swal(
            'Ops',
            'Erro ao adicionar módulo',
            'error'
          )
        }).finally(() => {
          this.loading = false
          this.$refs.form.resetValidation()
        })
      }
    },
    editModule (moduleId) {
      let index = this.modules.findIndex(module => {
        return String(moduleId) === String(module._id)
      })

      for (let i = 0; i < this.modules.length; i++) {
        this.modules[i].color = ''
      }

      if (this.modules[index]._id !== this.moduleId) {
        this.appendOuterIcon = 'check'
        this.modulePresential = (this.modules[index].presential ? 1 : 0)
        if (this.modules[index].startAt) {
          this.moduleStartDate = this.formatDate(this.modules[index].startAt.substr(0, 10))
        }
        this.moduleName = this.modules[index].title
        this.moduleId = this.modules[index]._id
        this.modules[index].color = 'orange'
      } else {
        this.moduleId = ''
        this.appendOuterIcon = 'add'
        this.moduleStartDate = ''
        this.moduleName = ''

        this.$refs.form.resetValidation()
      }
    },
    addModuleEvent (e) {
      if (e.key === 'Enter') {
        this.addModule()
      }
    },
    removeModule (index) {
      let module = this.modules[index]

      this.$swal({
        title: 'Confirma a exclusão do módulo?',
        text: 'O conteúdo dentro dele também será apagado',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#cf3034',
        cancelButtonColor: '#0077bd',
        confirmButtonText: 'Confirmar exclusão',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.value) {
          this.axios.delete(`/user/module/${module._id}`).then(({ data }) => {
            if (data.success) {
              this.modules.splice(index, 1)
            }
          }).catch(() => {
            this.$swal(
              'Ops',
              'Erro ao excluir o módulo',
              'error'
            )
          })
        }
      })
    },
    getModules (courseId) {
      this.axios.get(`/user/course/modules/${courseId}`).then(response => {
        if (response.data.success) {
          this.modules = response.data.modules
        }
      }).catch(err => {
        console.error(err)
      })
    },
    next () {
      if (this.courseHasModules && !this.modules.length) {
        this.$swal(
          'Ops',
          'Inclua módulos no curso',
          'info'
        )

        return false
      }

      if (!this.courseHasModules && this.modules.length) {
        this.$swal({
          title: 'Confirma a exclusão de todos os módulos?',
          text: 'Se houver vídeos dentro do módulos, estes também serão excluídos',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#cf3034',
          cancelButtonColor: '#0077bd',
          confirmButtonText: 'Confirmar exclusão',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.value) {
            this.axios.delete(`/module/all/${this.courseId}`).then(({ data }) => {
              if (data.success) {
                this.$router.push({ name: 'course-create-step3', params: { courseId: this.courseId } })
              }
            }).catch(() => {
              this.$swal(
                'Ops',
                'Erro ao excluir os módulos',
                'error'
              )
            })
          }
        })
      } else {
        this.$router.push({ name: 'course-create-step3', params: { courseId: this.courseId } })
      }
    }
  }
}
</script>
